import { USAGE_TYPE } from "../../../types/bookings";

export const isResidentialUsageType = (usageType?: string): boolean => {
  if (!usageType) return false;
  return usageType.toLowerCase() === USAGE_TYPE.RESIDENTIAL;
};
